var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronDownNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.415 1.472a1.999 1.999 0 0 0-2.83 0l-6.114 6.113a.667.667 0 0 1-.943 0L3.415 1.472A2 2 0 0 0 .585 4.3L6.7 10.415a4.669 4.669 0 0 0 6.6 0L19.415 4.3a2 2 0 0 0 0-2.828Z",
  fill: "currentColor"
})));
export default SvgChevronDownNew;